<template>
  <div>
    <div>
      <h1>Current Revenue</h1>
    </div>
    <div class="form-section">
      <summary-col>
        <h3>Mortgages</h3>
      </summary-col>
      <data-col>
        <data-row>
          <label>Average Monthly Number of Mortgage Sign-Ups</label>
          <div class="input-wrapper">
          <input class="data-input" v-model="monthlyAvgMortgageSignup"/>
          </div>
        </data-row>
        <data-row>
          <label>Average Application Fee</label>
          <div class="input-wrapper">
          <input class="data-input" v-model="appFee"/>
          </div>
        </data-row>
        <data-row>
          <label class="section-summary-label">Monthly Mortgage Income</label>
          <div class="data-summary-wrapper">
          <div class="data-summary">£{{ monthlyAvgMortgageSignup * appFee }}</div>
          </div>
        </data-row>
      </data-col>
    </div>
    <div class="form-section">
      <summary-col>
          <h3>Protection</h3>
      </summary-col>
      <data-col>
        <data-row>
          <label>Average Number of Protection Cases</label>
          <div class="input-wrapper">
          <input class="data-input" v-model="lifeCover"/>
          </div>
        </data-row>
        <data-row>
          <label>Average Premium</label>
          <div class="input-wrapper">
          <input class="data-input" v-model="avgLifePremium"/>
          </div>
        </data-row>
        <data-row>
          <label>Average Commission %</label>
          <div class="input-wrapper">
          <input class="data-input" v-model="avgLifeCommission"/>
          </div>
        </data-row>
        <data-row>
          <label class="section-summary-label">Monthly Protection Income</label>
          <div class="data-summary-wrapper">
          <div class="data-summary">£{{ lifeCover * avgLifeCommission }}</div>
          </div>
        </data-row>
      </data-col>
    </div>
    <div class="form-section">
      <summary-col>
          <h3>Buildings & Contents</h3>
      </summary-col>
      <data-col>
        <data-row>
          <label>Average Number of Buildings & Contents Cases</label>
          <div class="input-wrapper">
          <input class="data-input" v-model="bins"/>
          </div>
        </data-row>
        <data-row>
          <label>Average Premium</label>
          <div class="input-wrapper">
          <input class="data-input" v-model="avgBinsPremium"/>
          </div>
        </data-row>
        <data-row>
          <label>Average Commission</label>
          <div class="input-wrapper">
          <input class="data-input" v-model="avgBinsCommission"/>
          </div>
        </data-row>
        <data-row>
          <label class="section-summary-label">Monthly Buillding & Contents Income</label>
          <div class="data-summary-wrapper">
          <div class="data-summary">£{{ bins * avgBinsCommission }}</div>
          </div>
        </data-row>
      </data-col>
    </div>
    <div id="form-footer">
      <div class="button-wrapper back-button-wrapper">
        <BtnBack title="Back"/>
      </div>
      <div class="button-wrapper next-button-wrapper">
        <BtnNext title="Next" currentPage="current-revenue" />
      </div>
    </div>
  </div>
</template>

<script>
import BtnNext from './BtnNext.vue'
import BtnBack from './BtnBack.vue'
export default {
  props: {
  },
  computed: {
      monthlyAvgMortgageSignup: {
        get () {
          return this.$store.state.currentRevenues.mortgages.monthlyAvgSignup
        },
        set (value) {
          this.$store.commit('setMonthlyAvgMortgageSignup', value)
          //this.$store.commit('setLifeCover', Math.round(value * 0.5))
          //this.$store.commit('setBinsCover', value)
        }
      },
      appFee: {
        get () {
          return this.$store.state.currentRevenues.mortgages.appFee
        },
        set (value) {
          this.$store.commit('setAppFee', value)
        }
      },
      lifeCover: {
        get () {
          return this.$store.state.currentRevenues.life.cases
        },
        set (value) {
          this.$store.commit('setLifeCover', value)
        }
      },
      avgLifePremium: {
        get () {
          return this.$store.state.currentRevenues.life.avgPremium
        },
        set (value) {
          this.avgLifeCommission = 22 * value
          this.$store.commit('setLifeAvgPremium', value)
        }
      },
      avgLifeCommission: {
        get () {
          return this.$store.state.currentRevenues.life.avgCommission
        },
        set (value) {
          this.$store.commit('setLifeAvgCommission', value)
        }
      },
      bins: {
        get () {
          return this.$store.state.currentRevenues.bins.cases
        },
        set (value) {
          this.$store.commit('setBinsCover', value)
        }
      },
      avgBinsPremium: {
        get () {
          return this.$store.state.currentRevenues.bins.avgPremium
        },
        set (value) {
          this.avgBinsCommission = 3 * value
          this.$store.commit('setBinsAvgPremium', value)
        }
      },
      avgBinsCommission: {
        get () {
          return this.$store.state.currentRevenues.bins.avgCommission
        },
        set (value) {
          this.$store.commit('setBinsAvgCommission', value)
        }
      },
  },
  components: {
    BtnNext,
    BtnBack
  }
}
</script>
